"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = Toggle;

var _toggle = require("../../toggle");

var _reactForms = require("@seegno/react-forms");

var _react = _interopRequireDefault(require("react"));

var _excluded = ["disabled", "label", "name"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Export `Toggle` component.
 */
function Toggle(props) {
  var disabled = props.disabled,
      label = props.label,
      name = props.name,
      rest = _objectWithoutProperties(props, _excluded);

  var _useField = (0, _reactForms.useField)(name),
      onBlur = _useField.onBlur,
      onChange = _useField.onChange,
      onFocus = _useField.onFocus,
      value = _useField.value;

  var _useFormState = (0, _reactForms.useFormState)(),
      isSubmitting = _useFormState.isSubmitting;

  var isDisabled = disabled || isSubmitting;
  return /*#__PURE__*/_react["default"].createElement(_toggle.BaseToggle, _extends({}, rest, {
    "aria-label": label,
    checked: value !== null && value !== void 0 ? value : false,
    disabled: isDisabled,
    name: name,
    onBlur: onBlur,
    onFocus: onFocus,
    onToggle: function onToggle() {
      return onChange(!value);
    }
  }));
}